import React from 'react';
import moment from 'moment';

const FormatSeconds = ({seconds}) => {
    if (!seconds) {
        return null;
    }

    let label = '';
    const parsed = moment.duration(seconds, 'seconds');
    if (parsed.days() > 0) {
        label += `${parsed.days()} ${parsed.days() === 1 ? 'dag': 'dagar'}, `;
    }
    if (parsed.hours() > 0) {
        label += `${parsed.hours()} tim`;
    }
    if (parsed.minutes() > 0) {
        label += `, ${parsed.minutes()} min`;
    }
    return <span>ca {label}</span>
};

export { FormatSeconds };



// WEBPACK FOOTER //
// ./src/components/Time.js